export default __webpack_public_path__ + "static/media/img_hitachi-colorBkg.fdfd8a52.png";